import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import { User } from "../types/User";
import "../../static/css/UserRow.css";
import x from '../../static/images/x.png'
interface UserRowProps {
  user: User;
  roleOptions: { label: string; value: string }[];
  onRoleChange: (username: string, roles: string) => void;
}
interface RoleOption {
  label: string;
  value: string;
  id?: number;
}
// UserRow component to display user information in a table row
const UserRow: React.FC<UserRowProps> = ({
  user,
  roleOptions,
  onRoleChange,
}) => {
  const [selectedRoles, setSelectedRoles] = useState<RoleOption[]>(() => {
    if (!user.role) return [];

    const userRoles = user.role.split(", ");
    return roleOptions.filter((option) => userRoles.includes(option.value));
  });

  useEffect(() => {
    if (user.role) {
      const userRoles = user.role.split(", ");
      const matchingRoles = roleOptions.filter((option) =>
        userRoles.includes(option.value)
      );

      setSelectedRoles(matchingRoles);
    } else {
      setSelectedRoles([]);
    }
  }, [user.role, roleOptions]);

  // Notify parent when roles change
  useEffect(() => {
    const roles = selectedRoles.map((role) => role.value).join(", ");
    if (roles !== user.role) {
      onRoleChange(user.username, roles);
    }
  }, [selectedRoles, user.username, user.role, onRoleChange]);

  // Handle role selection in the multiselect dropdown
  const handleSelect = (selectedList: { label: string; value: string }[]) => {
    setSelectedRoles(selectedList);
  };
  // Handle role removal from the multiselect dropdown
  const handleRemove = (removedList: { label: string; value: string }[]) => {
    setSelectedRoles(removedList);
  };

  return (
    <tr>
      <td className="p-3">{user.firstName}</td>
      <td className="p-3">{user.lastName}</td>
      <td className="p-3">{user.email}</td>
      <td className="p-3">
        <Multiselect
          options={roleOptions}
          selectedValues={selectedRoles}
          onSelect={handleSelect}
          onRemove={handleRemove}
          displayValue="label"
          avoidHighlightFirstOption
          className="custom-multiselect"
      
          customCloseIcon={<img style={{ width: "1rem", height: "1rem", marginLeft:'1rem' }} src={x} alt="close" />}
         
        />
        
      </td>
    </tr>
  );
};

export default UserRow;
